import { motion } from "framer-motion";

import EmbedFrame from "@/components/EmbedFrame";
import SectionHeading from "@/components/SectionHeading";
import SmartLink from "@/components/SmartLink";
import { Button } from "@/components/ui/button";

function EmbedCard({ item }) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="font-sans text-xl font-semibold text-foreground mb-2">{item.title}</h3>
        {item.description ? <p className="font-body text-muted-foreground">{item.description}</p> : null}
      </div>
      <EmbedFrame
        embedHtml={item.embedHtml}
        embedUrl={item.embedUrl}
        title={item.title}
        placeholderLabel={item.placeholderLabel}
      />
      {item.cta ? (
        <Button asChild className="rounded-full bg-secondary hover:bg-secondary/85 text-white font-medium px-6 btn-hover">
          <SmartLink href={item.cta.href} external={item.cta.external}>
            {item.cta.label}
          </SmartLink>
        </Button>
      ) : null}
    </div>
  );
}

export default function VideoShowcaseSection({ content, dataTestId, className = "" }) {
  const hasPlaylist = Boolean(content.playlist);

  return (
    <section className={`py-16 md:py-24 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <SectionHeading title={content.title} description={content.description} />
        </motion.div>
        <div className={`grid grid-cols-1 gap-8 lg:gap-10 ${hasPlaylist ? "xl:grid-cols-2" : "max-w-3xl mx-auto"}`.trim()}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <EmbedCard item={content.featured} />
          </motion.div>
          {hasPlaylist ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <EmbedCard item={content.playlist} />
            </motion.div>
          ) : null}
        </div>
        <div className="mt-8 flex justify-center">
          <Button asChild size="lg" className="rounded-full bg-primary hover:bg-primary/90 text-white font-medium px-8 btn-hover">
            <SmartLink href={content.primaryCta.href} external={content.primaryCta.external}>
              {content.primaryCta.label}
            </SmartLink>
          </Button>
        </div>
      </div>
    </section>
  );
}
